// @flow

type Commander = {};
type ProjectConfig = {
  templates: {},
};

type Env = {};

export default { Commander, ProjectConfig, Env };
